import React from "react";
import { Box, IconButton, InputBase } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import { updateCartItemQuantity } from "../utils/cartSync";

const QuantitySelector = ({
  value,
  setValue,
  min = 1,
  step = 1,
  item = null,
  sync = false,
}) => {
  const handleChange = async (newVal) => {
    if (!isNaN(newVal) && newVal >= min) {
      setValue(newVal);

      if (sync && item) {
        try {
          await updateCartItemQuantity(item, newVal);
        } catch (err) {
          console.warn("❌ Failed to sync quantity change", err);
        }
      }
    }
  };

  const sizeStyles = {
    width: 34,
    height: 32,
    fontSize: "1rem",
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #ccc",
        borderRadius: "6px",
        overflow: "hidden",
        maxWidth: "150px",
      }}>
      <IconButton
        size="large"
        onClick={() => handleChange(value - step)}
        disabled={value <= min}
        sx={sizeStyles}>
        <Remove fontSize="inherit" />
      </IconButton>

      <InputBase
        type="number"
        value={value}
        onChange={(e) => {
          const raw = e.target.value;
          const parsed = Number(raw);

          if (!isNaN(parsed)) {
            const clamped = Math.min(Math.max(min, Math.floor(parsed)), 1000);
            handleChange(clamped);
          }
        }}
        inputProps={{
          min,
          max: 1000,
          step,
          style: {
            textAlign: "center",
            ...sizeStyles,
            MozAppearance: "textfield",
          },
        }}
        sx={{
          width: sizeStyles.width,
          "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
            {
              WebkitAppearance: "none",
              margin: 0,
            },
        }}
      />

      <IconButton
        size="medium"
        onClick={() => handleChange(value + step)}
        sx={sizeStyles}>
        <Add fontSize="inherit" />
      </IconButton>
    </Box>
  );
};

export default QuantitySelector;
